import { render, staticRenderFns } from "./MeetingView.vue?vue&type=template&id=3b4afcd8&scoped=true&"
import script from "./MeetingView.vue?vue&type=script&lang=ts&"
export * from "./MeetingView.vue?vue&type=script&lang=ts&"
import style0 from "./MeetingView.vue?vue&type=style&index=0&id=3b4afcd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4afcd8",
  null
  
)

export default component.exports